import { useEffect, useState } from "react";

import { verifyPortalToken } from "@/stores/authSlice";
import { useAppDispatch } from "@/stores/hooks";
import { getTokenFromUrl, stripTokenFromUrl } from "@/utils/token";

export const useVerifyToken = () => {
  const dispatch = useAppDispatch();
  const [isVerifying, setIsVerifying] = useState(() => !!getTokenFromUrl());

  useEffect(() => {
    const token = getTokenFromUrl();
    if (!token) {
      setIsVerifying(false);
      return;
    }

    stripTokenFromUrl();
    dispatch(verifyPortalToken(token))
      .unwrap()
      .then(() => {
        const hasReloaded = sessionStorage.getItem("hasReloadedAfterLogin");
        if (!hasReloaded) {
          sessionStorage.setItem("hasReloadedAfterLogin", "true");
          window.location.reload();
        }
      })
      .catch(() => {})
      .finally(() => setIsVerifying(false));
  }, [dispatch]);

  return { isVerifying };
};
